import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HeartHandshake, Menu, X, User } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Beranda',
    path: '/'
  }, {
    name: 'Layanan',
    path: '/layanan'
  }, {
    name: 'Artikel',
    path: '/artikel'
  }, {
    name: 'Tes Minat',
    path: '/tes'
  }, {
    name: 'Tentang BK',
    path: '/tentang'
  }, {
    name: 'Kontak',
    path: '/kontak'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="bg-gradient-to-r from-pink-50/90 via-white/90 to-blue-50/90 backdrop-blur-md sticky top-0 z-50 shadow-sm" data-id="element-68">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-69">
        <div className="flex justify-between h-16" data-id="element-70">
          <div className="flex items-center" data-id="element-71">
            <Link to="/" className="flex items-center gap-2 group" data-id="element-72">
              <div className="bg-gradient-to-br from-pink-400 to-blue-400 p-2 rounded-xl group-hover:from-pink-500 group-hover:to-blue-500 transition-all duration-300 shadow-sm" data-id="element-73">
                <HeartHandshake className="h-6 w-6 text-white" data-id="element-74" />
              </div>
              <span className="font-bold text-xl bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent tracking-tight" data-id="element-75">
                CLBK
              </span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-1" data-id="element-76">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${isActive(link.path) ? 'bg-gradient-to-r from-pink-100 to-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gradient-to-r hover:from-pink-50 hover:to-blue-50 hover:text-pink-600'}`} data-id="element-77">
                {link.name}
              </Link>)}
            <Link to="/login" className="ml-4 flex items-center gap-2 bg-gradient-to-r from-pink-400 to-blue-400 text-white px-4 py-2 rounded-full font-medium hover:from-pink-500 hover:to-blue-500 transition-all shadow-sm hover:shadow-md" data-id="element-78">
              <User size={16} data-id="element-79" />
              <span data-id="element-80">Masuk</span>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="flex items-center md:hidden" data-id="element-81">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-primary focus:outline-none p-2" data-id="element-82">
              {isOpen ? <X size={24} data-id="element-83" /> : <Menu size={24} data-id="element-84" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-85">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-gradient-to-b from-pink-50/50 to-blue-50/50 border-t border-gray-100 overflow-hidden" data-id="element-86">
            <div className="px-4 pt-2 pb-4 space-y-1" data-id="element-87">
              {navLinks.map(link => <Link key={link.name} to={link.path} onClick={() => setIsOpen(false)} className={`block px-3 py-3 rounded-lg text-base font-medium ${isActive(link.path) ? 'bg-gradient-to-r from-pink-100 to-blue-100 text-blue-700' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-88">
                  {link.name}
                </Link>)}
              <Link to="/login" onClick={() => setIsOpen(false)} className="mt-4 flex items-center justify-center gap-2 bg-gradient-to-r from-pink-400 to-blue-400 text-white px-4 py-3 rounded-xl font-medium hover:from-pink-500 hover:to-blue-500 transition-all" data-id="element-89">
                <User size={18} data-id="element-90" />
                <span data-id="element-91">Masuk / Daftar</span>
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}